import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import EditIcon from '@material-ui/icons/Edit';

export const FormHead = ({ formulaire }: { formulaire: any }) => {
    return (
        <Grid container style={{ paddingTop: 20 }} alignItems="center">
            <Grid item xs={2}>
                <img src="/logo-sacem-2025.png" alt="logo sacem" style={{ height: '66px' }} />
            </Grid>
            <Grid item style={{ textAlign: 'center' }} xs={8}>
                <Typography >
                    {'FICHE TECHNIQUE PUBLICITAIRE'}
                    <span style={{ marginLeft: 10 }}>
                        {formulaire.is_validated ? (
                            <DoneOutlineIcon />
                        ) : (
                            <EditIcon />
                        )}
                    </span>
                </Typography>
            </Grid>
            <Grid item xs={2} justifyContent="flex-end">
                <Typography >
                    {'VERSION'} : {formulaire.version}
                </Typography>
            </Grid>
        </Grid>
    )
}